export const CODE_TYPE_REFERRAL = 1; // referral code record `type` column
export const CODE_TYPE_COUPON = 3;
export const REFERRAL = 'referral';
export const COUPON = 'coupon';
export const CodeTypes = {
  [REFERRAL]: CODE_TYPE_REFERRAL,
  [COUPON]: CODE_TYPE_COUPON,
};
